import { setMapApiKey, setLiveApiKey, setMapConfig } from './steerpathMapActions'
import update from 'immutability-helper';

//---------------------------------------------------------action creators ----------------------------------------------
export const SET_LOCATIONS = 'SET_LOCATIONS'
export function setLocations(slideCurrentIndex, payload) {
    return {
        type: SET_LOCATIONS,
        slideCurrentIndex,
        payload
    }
}

export const SET_DURATION = 'SET_DURATION'
export function setDuration(slideCurrentIndex, payload) {
    return {
        type: SET_DURATION,
        slideCurrentIndex,
        payload
    }
}

export const SET_LOCK_SCROLL = 'SET_LOCK_SCROLL'
export function setLockScroll(slideCurrentIndex, payload) {
    return {
        type: SET_LOCK_SCROLL,
        slideCurrentIndex,
        payload
    }
}

export const SET_WIDGET_LABEL_TYPE = 'SET_WIDGET_LABEL_TYPE'
export function setWidgetLabelType(slideCurrentIndex, payload) {
    return {
        type: SET_WIDGET_LABEL_TYPE,
        slideCurrentIndex,
        payload
    }
}

export const SENSOR_FILTER_TYPE = 'SENSOR_FILTER_TYPE'
export function setSensorFilterType(slideCurrentIndex, payload) {
    return {
        type: SENSOR_FILTER_TYPE,
        slideCurrentIndex,
        payload
    }
}

export const SET_STANDBY_SENSOR_TREATMENT = 'SET_STANDBY_SENSOR_TREATMENT'
export function setStandbySensorTreatment(slideCurrentIndex, payload) {
    return {
        type: SET_STANDBY_SENSOR_TREATMENT,
        slideCurrentIndex,
        payload
    }
}

//---------------------------------------------------------thunk action creators switch (Wrapper function ) ----------------------------------------------

export function setLivefeedGlobalOptions(type, payload) {
    return (dispatch, getState) => {
        const { livefeedSlides, slideCurrentIndex } = getState().livefeededitor;
        const { floorplanOptions: { liveApiKey, mapApiKey } } = livefeedSlides[slideCurrentIndex]
        const length = livefeedSlides.length
        switch (type) {
            case "globalSlideDuration":
                for (let i = 0; i < length; i++) {
                    if (i !== slideCurrentIndex) {
                        dispatch(setDuration(i, payload))
                    }
                }
                break;
            case "globalLockScroll":
                for (let i = 0; i < length; i++) {
                    if (livefeedSlides[i].slideType !== "summary" && livefeedSlides[i].slideType !== "locationsList") {
                        if (i !== slideCurrentIndex) {
                            dispatch(setLockScroll(i, payload))
                        }
                    }
                }
                break;
            case "globalWidget":
                for (let i = 0; i < length; i++) {
                    if (livefeedSlides[i].slideType !== "locationsList") {
                        if (i !== slideCurrentIndex) {
                            dispatch(setWidgetLabelType(i, payload))
                        }
                    }
                }
                break;
            case "globalSensorFilter":
                for (let i = 0; i < length; i++) {
                    if (livefeedSlides[i].slideType !== "locationsList") {
                        if (i !== slideCurrentIndex) {
                            dispatch(setSensorFilterType(i, payload.sensorFilterType))
                            dispatch(setStandbySensorTreatment(i, payload.isStandbyAsUnOccupied))
                        }
                    }
                }
                break;
            case "globalMapConfig":
                for (let i = 0; i < length; i++) {
                    if (i !== slideCurrentIndex) {
                        dispatch(setMapConfig(i, payload))
                        dispatch(setMapApiKey(i, mapApiKey))
                        dispatch(setLiveApiKey(i, liveApiKey))
                    }
                }
                break;

        }

    }
}

export function setLivefeedOptions(type, payload) {
    return (dispatch, getState) => {
        const { slideCurrentIndex, livefeedSlides } = getState().livefeededitor;
        const { floorplanOptions: { mapConfig } } = livefeedSlides[slideCurrentIndex]
        switch (type) {
            case "summaryLocations": {
                for (let i = 0, n = livefeedSlides.length; i < n; i++) {
                    dispatch(setLocations(i, payload))
                }
            }
                break;
            case "slideshowLocations":
                dispatch(setLocations(slideCurrentIndex, payload))
                break;
            case "slideDuration":
                dispatch(setDuration(slideCurrentIndex, payload))
                break;
            case "lockscroll":
                dispatch(setLockScroll(slideCurrentIndex, payload))
                break;
            case "widgetLabelType":
                dispatch(setWidgetLabelType(slideCurrentIndex, payload))
                break;
            case "sensorFilterType":
                dispatch(setSensorFilterType(slideCurrentIndex, payload))
                break;
            case "treatStandbySensor":
                dispatch(setStandbySensorTreatment(slideCurrentIndex, payload))
                break;
            case "mapApiKey":
                dispatch(setMapApiKey(slideCurrentIndex, payload))
                break;
            case "liveApiKey":
                dispatch(setLiveApiKey(slideCurrentIndex, payload))
                break;
            case "mapConfig": {
                let newMapConfig = update(mapConfig, { $merge: payload })
                dispatch(setMapConfig(slideCurrentIndex, newMapConfig))
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/livefeed/livefeedOptions.js